import { LightningAddOrShowFavouritiesEnum, LightningTabsEnum, LightningSearchTypeEnum } from "@/util/cosntants";
import { normalActionTypes } from "../actions/lightningAction";
import { IFavoriteModel, IFeatureCollectionModel, IGetCountriesTreeResModel, IGetLocationsResModel } from "@/util/http/Lightning/responseType";
import { IDrawnShape } from "@/util/http/Lightning/requestType";

interface ILightningModel {
    isShowFavouritiesModal: boolean;
    addOrShowFavouritiesModal?: LightningAddOrShowFavouritiesEnum;
    currentTab: LightningTabsEnum;
    countriesTreeData?: IGetCountriesTreeResModel[]; // Assuming this is the type for countries tree data, adjust as necessary
    // for favourities modal
    authorCode?: string, // author code for favourities modal
    favoritiesOptions?: IFavoriteModel, // options for favourities modal
    // for location's value
    radiusValue?: number,
    locationNameOrCoordinate?: string,
    selectedLocationItem?: IGetLocationsResModel;
    isGetCurrentLocation?: boolean; // 是否获取当前位置
    // for region's value
    finalRequestBoundaryState?: string[]
    finalRequestBoundaryCode?: string[]
    selectedCountry?: string[]
    // for Draw on map
    drawnShape?: IDrawnShape;
    // for search
    searchType: LightningSearchTypeEnum
    // for common
    successMessage?: string;
    errorMessage?: string;
    warningMessage?: string;
    isLoadingForRenderBoundary?: boolean;
    isLoadingForGetBoundary?: boolean;
    isLoadingForDownloadImages?: boolean;
    isLoadingForGetSearchResult?: boolean,
    isLoadingForGetProcessSearchResult?: boolean,
    isStartDownloadImage?: boolean;
    selectedFavoritiesInfo?: IFavoriteModel, // information for selected favourities
    isResetContentForCurrentTabChange?: boolean, // 是否需要重置当前选项卡的内容
    // for result
    searchResult?: IFeatureCollectionModel | null; // Assuming this is the type for search results, adjust as necessary
    isRestMapContentBeforeSearch?: boolean; // 是否需要在搜索前重置地图内容
    isClickedSearchResultButton?: boolean; // 是否点击了搜索结果按钮
    isGetAllUSAData?: boolean; // 是否获取所有美国数据
    //for region relate data
    selectedKeys?:string[] | number[];
    checkedKeys?:string[] | number[];
    expandedKeys?:string[] | number[];
    autoExpandParent?:boolean;
    needClearLocation?:boolean;
    needClearRegion?:boolean;
    needClearDrawMap?:boolean;
    detectedRadius?: number;
    tolerance?: number;
    windowWidth?:number;
    isFresh?:boolean;
}



const initialLightnings: ILightningModel = {
    isShowFavouritiesModal: false,
    addOrShowFavouritiesModal: null,
    currentTab: LightningTabsEnum.LOCATION,
    countriesTreeData: [], // Initialize with an empty array or appropriate default value
    authorCode: "", // Default author code
    // for location
    selectedLocationItem: null, // Default selected location item
    isGetCurrentLocation: false, // Default to false, indicating current location is not fetched
    radiusValue: 10, // Default radius value
    locationNameOrCoordinate: "", // Default value for location name or coordinates
    searchType: LightningSearchTypeEnum.FIRSTSTRIKE, // Default search type
    // for region
    finalRequestBoundaryState: [], // Default empty array for region boundaries
    finalRequestBoundaryCode: [], // Default empty array for region boundary codes
    selectedCountry: [], // Default empty array for selected countries
    // for Draw on map
    drawnShape: null, // Default drawn shape, can be null or an empty object
    // for common
    successMessage: "",
    errorMessage: "",
    warningMessage: "",
    isClickedSearchResultButton: false,
    isLoadingForRenderBoundary: false,
    isLoadingForGetBoundary: false,
    isLoadingForDownloadImages: false,
    isLoadingForGetSearchResult: false,
    isLoadingForGetProcessSearchResult: false,
    isStartDownloadImage: false,
    isGetAllUSAData: true, // Default to true to indicate all USA data should be fetched
    searchResult: null, // Initialize with an empty array or appropriate default value
    selectedKeys:[],
    checkedKeys:[],
    expandedKeys:["United States"],
    autoExpandParent:true,
    needClearLocation:false,
    needClearRegion:false,
    needClearDrawMap:false,
    detectedRadius: 2,
    tolerance: 0.003,
    isFresh:false,
};

const lightningReducer = (state: ILightningModel = initialLightnings, action) => {

    switch (action.type) {
        case normalActionTypes.NORMAL_UPDATE_ISSHOWFAVOURITIESMODAL:
            console.log("action.payload", action.payload);
            return {
                ...state,
                isShowFavouritiesModal: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_CURRENTTAB:
            return{
                ...state,
                currentTab: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_ADDORSHOWFAVOURITIESMODAL:
            return{
                ...state,
                addOrShowFavouritiesModal: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_AUTHORCODE:
            return {
                ...state,
                authorCode: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_FAVORIESOPTIONS:
            return {
                ...state,
                favoritiesOptions: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_SELECTEDFAVORIESINFO:
            return {
                ...state,
                selectedFavoritiesInfo: action.payload
            };
        // for location
        case normalActionTypes.NORMAL_UPDATE_LOCATION_LOCATIONNAMEORCOORDINATE:
            return {
                ...state,
                locationNameOrCoordinate: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_LOCATION_RADIUSVALUE:
            return {
                ...state,
                radiusValue: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_LOCATION_SELECTEDLOCATIONITEM:
            return {
                ...state,
                selectedLocationItem: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_LOCATION_ISGETCURRENTLOCATION:
            return {
                ...state,
                isGetCurrentLocation: action.payload
            };
        // for region
        case normalActionTypes.NORMAL_UPDATE_COUNTRESTREEDATA:
            return{
                ...state,
                countriesTreeData: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_REGION_FINALREQUESTBOUNDARYSTATE:
            return {
                ...state,
                finalRequestBoundaryState: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_REGION_FINALREQUESTBOUNDARYCODE:
            return {
                ...state,
                finalRequestBoundaryCode: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_REGION_SELECTED_COUNTRY:
            return {
                ...state,
                selectedCountry: action.payload
            };
        // for Draw on map
        case normalActionTypes.NORMAL_UPDATE_DRAWONMAP_DRAWNSHAPE:
            return {
                ...state,
                drawnShape: action.payload
            };
        // for search
        case normalActionTypes.NORMAL_UPDATE_SEARCHTYPE:
            return {
                ...state,
                searchType: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_SEARCHRESULT:
            return {
                ...state,
                searchResult: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_ISCLICKEDSEARCHRESULTBUTTON:
            return {
                ...state,
                isClickedSearchResultButton: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_ISRESETMAPCONTENTBEFORESEARCH:
            return {
                ...state,
                isRestMapContentBeforeSearch: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_ISGETALLUSADATA:
            return {
                ...state,
                isGetAllUSAData: action.payload
            };
        // for common
        case normalActionTypes.NORMAL_UPDATE_SUCCESSMESSAGE:
            return {
                ...state,
                successMessage: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_ERRORMESSAGE:
            return {
                ...state,
                errorMessage: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_WARNINGMESSAGE:
            return {
                ...state,
                warningMessage: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_ISLOADINGFORRENDERBOUNDARY:
            return {
                ...state,
                isLoadingForRenderBoundary: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_ISLOADINGFORGETBOUNDARY:
            return {
                ...state,
                isLoadingForGetBoundary: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_ISLOADINGFORDOWNLOADIMAGES:
            return {
                ...state,
                isLoadingForDownloadImages: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_ISLOADINGFORGETSEARCHRESULT:
            return {
                ...state,
                isLoadingForGetSearchResult: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_ISLOADINGFORGETPROCESSSEARCHRESULT:
            return {
                ...state,
                isLoadingForGetProcessSearchResult: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_ISSTARTDOWNLOADIMAGE:
            return {
                ...state,
                isStartDownloadImage: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_ISRESTCONTENTFORCURRENTTABCHANGE:
            return {
                ...state,
                isResetContentForCurrentTabChange: action.payload
            };
            //for region
        case normalActionTypes.NORMAL_UPDATE_EXPANDEDKEYS:
            return {
                ...state,
                expandedKeys: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_CHECKEDKEYS:
            return {
                ...state,
                checkedKeys: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_SELECTEDKEYS:
            return {
                ...state,
                selectedKeys: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_AUTOEXPANDEDPARENT:
            return {
                ...state,
                autoExpandParent: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_NEEDCLEARLOCATION:
            return {
                ...state,
                needClearLocation: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_NEEDCLEARREGION:
            return {
                ...state,
                needClearRegion: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_NEEDCLEARDRAWMAP:
            return {
                ...state,
                needClearDrawMap: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_DETECCTEDRADIUS:
            return {
                ...state,
                detectedRadius: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_TOLERANDCE:
            return {
                ...state,
                tolerance: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_WINDOWWIDTH:
            return {
                ...state,
                windowWidth: action.payload
            };
        case normalActionTypes.NORMAL_UPDATE_ISREFRESH:
            return {
                ...state,
                isFresh: action.payload
            };
        default:
            return state;
    }
};

export type {
    ILightningModel
};

export default lightningReducer;